"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var Telemetry_1 = require("Common/Telemetry/Telemetry");
var inversify_1 = require("inversify");
var inversify_react_1 = require("inversify-react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var TourOrchestrator_1 = require("Onboarding/Tour/TourOrchestrator/TourOrchestrator");
var react_1 = __importStar(require("react"));
var DiscoverStore_1 = __importDefault(require("./DiscoverStore"));
var HelpButton_1 = require("./HelpButton/HelpButton");
var Sidebar_1 = require("./Sidebar");
var TrialPill_1 = require("./Trial/TrialPill");
var TourEndPrompt_1 = require("./TourEndPrompt/TourEndPrompt");
var c = (0, BemBuilder_1.default)("discover");
var Discover = (function (_super) {
    __extends(Discover, _super);
    function Discover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleButtonClick = function () {
            _this.tourOrchestrator.handleActionedPrompt();
            if (_this.discoverStore.isHelpOpen) {
                if (_this.discoverStore.isSidebarOpen) {
                    _this.telemetry.trackOnly("Discover Sidebar Dismissed");
                }
                _this.discoverStore.closeHelp();
            }
            else {
                if (_this.discoverStore.isSidebarEnabled) {
                    _this.telemetry.trackOnly("Discover Sidebar Viewed");
                }
                _this.discoverStore.openHelp();
            }
        };
        _this.handleDismissPrompt = function () {
            _this.tourOrchestrator.handleActionedPrompt();
        };
        _this.handleTrialClick = function () {
            _this.telemetry.trackOnly("Upgrade Prompt Viewed", { upgrade_prompt_view_origin: "help pill" });
            _this.discoverStore.upgradeTrialAccount();
        };
        return _this;
    }
    Discover.prototype.componentDidMount = function () {
        var _this = this;
        (0, mobx_1.reaction)(function () { return _this.discoverStore.shouldInitBeacon; }, function (init) {
            if (init) {
                _this.discoverStore.initBeacon();
            }
        }, { fireImmediately: true });
    };
    Discover.prototype.render = function () {
        var _a;
        if (!this.discoverStore.shouldShowHelpButton) {
            return null;
        }
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c(), (_a = {},
                _a[c(undefined, "open")] = this.discoverStore.isSidebarOpen,
                _a)) },
            react_1.default.createElement("div", { className: c("buttons") },
                react_1.default.createElement(HelpButton_1.HelpButton, { isOpen: this.discoverStore.isHelpOpen, onClick: this.handleButtonClick }),
                this.discoverStore.shouldShowTrialPill && react_1.default.createElement(TrialPill_1.TrialPill, { onClick: this.handleTrialClick }),
                react_1.default.createElement(TourEndPrompt_1.TourEndPrompt, { show: this.tourOrchestrator.shouldShowPrompt, onClose: this.handleDismissPrompt })),
            react_1.default.createElement("div", { className: c("sidebar-outer") },
                react_1.default.createElement("div", { className: c("sidebar-inner") },
                    react_1.default.createElement(Sidebar_1.Sidebar, null)))));
    };
    var _a, _b, _c;
    __decorate([
        (0, inversify_react_1.resolve)("discoverStore"),
        __metadata("design:type", typeof (_a = typeof DiscoverStore_1.default !== "undefined" && DiscoverStore_1.default) === "function" ? _a : Object)
    ], Discover.prototype, "discoverStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("telemetry"),
        __metadata("design:type", typeof (_b = typeof Telemetry_1.Telemetry !== "undefined" && Telemetry_1.Telemetry) === "function" ? _b : Object)
    ], Discover.prototype, "telemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("tourOrchestrator"),
        __metadata("design:type", typeof (_c = typeof TourOrchestrator_1.TourOrchestrator !== "undefined" && TourOrchestrator_1.TourOrchestrator) === "function" ? _c : Object)
    ], Discover.prototype, "tourOrchestrator", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Discover.prototype, "handleButtonClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Discover.prototype, "handleDismissPrompt", void 0);
    Discover = __decorate([
        mobx_react_1.observer
    ], Discover);
    return Discover;
}(react_1.Component));
function mountDiscover() {
    return (react_1.default.createElement(DIProvider_1.default, { container: function () { return new inversify_1.Container(); } },
        react_1.default.createElement(Discover, null)));
}
exports.default = mountDiscover;
